import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useState } from 'react';
import { FilledInput } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import CopyToClipboardWrapper from '../CopyToClipboardWrapper.js';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import AssignmentIcon from '@mui/icons-material/Assignment';

const FormInput = ({
  color = 'primary',
  name = '',
  type = 'text',
  title = '',
  rows = '10',
  placeholder = '',
  onChange = undefined,
  disabled = false,
  copyBytton = false,
  children = null,
  size = 'small',
  variant = 'filled',
  options = [],
  formik: {
    values = {},
    errors = {},
    handleChange = undefined
  }
}) => {
  const [openTip, setOpenTip] = useState(false);
  const handleClickButton = () => {
    setOpenTip(true);
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    color: color,
    variant: variant,
    fullWidth: true,
    focused: true
  }, type !== 'datetime' && type !== 'select' && type !== 'checkbox' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: name
  }, title || name), /*#__PURE__*/React.createElement(FilledInput, {
    size: size,
    color: color,
    id: name,
    disabled: disabled,
    type: type,
    name: name,
    onChange: async e => {
      if (handleChange) await handleChange(e);
      if (onChange) await onChange(e);
      setOpenTip(false);
    },
    value: values[name] || '',
    rows: rows,
    placeholder: placeholder,
    style: {
      verticalAlign: 'middle',
      position: 'relative'
    },
    multiline: type === 'textarea',
    endAdornment: copyBytton && /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(CopyToClipboardWrapper, {
      text: values[name] || ''
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: values[name] === '',
      onClick: handleClickButton
    }, /*#__PURE__*/React.createElement(AssignmentIcon, {
      color: openTip ? 'disabled' : color
    }))))
  })), type === 'select' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputLabel, {
    id: name + '-label'
  }, title), /*#__PURE__*/React.createElement(Select, {
    size: size,
    labelId: name + '-label',
    id: name,
    value: values[name],
    label: title ? `${title} (${name})` : name,
    onChange: async (e, child) => {
      handleChange && (await handleChange(e));
      onChange && (await onChange(e, child));
    },
    name: name,
    disabled: disabled
  }, options.map((item, index) => /*#__PURE__*/React.createElement(MenuItem, {
    key: index,
    value: item.value,
    divider: item.divider
  }, item.label || item.value)))), type === 'datetime' && /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterDayjs
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    label: title || name,
    inputFormat: "YYYY-MM-DDTHH:mm:ss",
    value: values[name] || '',
    onChange: async e => {
      const event = {
        target: {
          value: e.format('YYYY-MM-DDTHH:mm:ss'),
          name
        }
      };
      if (onChange) await onChange(event);
      if (handleChange) await handleChange(event);
    },
    renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      variant: 'filled',
      color: color,
      focused: true,
      fullWidth: true,
      size: size
    }))
  })), type === 'checkbox' && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: values[name],
      onChange: async e => {
        const event = {
          target: {
            value: e.target.checked,
            name
          }
        };
        if (onChange) await onChange(event);
        if (handleChange) await handleChange(event);
      },
      name: name,
      color: color
    }),
    label: title || name
  }), /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors[name]), children);
};

export { FormInput };
